// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================
   Documents grid
   ========================================= */

.documents-list {
  margin: 0.5rem 0;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}

.documents-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: stretch;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}

/* Carte "trailing" (contenu libre passe via le prop \`trailingCard\`) : occupe DEUX places de carte.
   - variant "grid" (display:grid, repeat(4,1fr)) -> grid-column: span 2 (2 des 4 colonnes).
   - variants flex (inline/fullWidth) -> flex 2 1 400px (2x une carte flex 1 1 200px).
   Meme hauteur que les cartes (les items s'etirent sur la ligne). display:flex pour que le contenu remplisse. */
.documents-grid-trailing {
  grid-column: span 2;
  flex: 2 1 400px;
  max-width: 800px;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
}
.documents-grid-trailing > * {
  flex: 1 1;
  min-width: 0;
}

/* \`trailingCardSpan={1}\` : la carte tient dans UNE place, comme un document — elle reste donc sur la
   ligne des autres au lieu d'en manger deux. Les DEUX mecanismes de la regle de base sont annules,
   pas seulement le \`grid-column\` : les variants flex (inline/fullWidth) passent par \`flex\`, et n'en
   corriger qu'un laisserait la carte double dans la moitie des cas.
   \`max-width\` remis a la largeur d'une carte flex, sinon les 800px herites la laisseraient s'etaler. */
.documents-grid-trailing--single {
  grid-column: span 1;
  flex: 1 1 200px;
  max-width: 400px;
}

/* =========================================
   Document card
   ========================================= */

.document-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.125rem 1.25rem;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  cursor: pointer;
  flex: 1 1 200px;
  max-width: 400px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition:
    box-shadow 0.15s ease,
    border-color 0.15s ease;
  min-height: 88px;
}

.document-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #d1d5db;
}

/* Icône PDF */
.document-card-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1px solid #e5e7eb;
}

.document-card-icon--green {
  background: #f0fdf4;
  color: #16a34a;
}

.document-card-icon--orange {
  background: #fff7ed;
  color: #f97316;
}

.document-card-icon--grey {
  background: #f3f4f6;
  color: #6b7280;
}

.document-card-icon svg {
  width: 24px;
  height: 24px;
}

/* Corps : type + date */
.document-card-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.document-card-type {
  font-size: 1.45rem;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
}

.document-card-date {
  font-size: 1.2rem;
  color: #9ca3af;
  line-height: 1.2;
}

/* Bouton téléchargement */
.document-card-download {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.4rem;
  border-radius: 6px;
  color: #9ca3af;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition:
    background 0.15s ease,
    color 0.15s ease;
}

.document-card-download:hover:not(:disabled) {
  background: #fff7ed;
  color: #f97316;
}

.document-card-download:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Variant inline (contextes embarqués, liste compacte) */
.documents-grid-inline {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

/* Variant grid (Coordonnées — grille 4 colonnes) */
.documents-grid.documents-grid-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.625rem;
  flex-wrap: unset;
}

.document-card-grid {
  flex: unset;
  max-width: unset;
  min-height: unset;
  padding: 0.75rem 1rem;
  gap: 0.75rem;
}

.document-card-grid .document-card-icon {
  width: 54px;
  height: 54px;
  border-radius: 12px;
}

.document-card-grid .document-card-icon svg {
  width: 27px;
  height: 27px;
}

.document-card-grid .document-card-type {
  font-size: 1.25rem;
}

.document-card-grid .document-card-date {
  font-size: 1.1rem;
}

.document-card-inline {
  flex: unset;
  max-width: unset;
  min-height: unset;
  padding: 0.75rem 1rem;
  gap: 0.75rem;
}

.document-card-inline .document-card-icon {
  width: 54px;
  height: 54px;
  border-radius: 12px;
}

.document-card-inline .document-card-icon svg {
  width: 27px;
  height: 27px;
}

.document-card-inline .document-card-type {
  font-size: 1.25rem;
}

.document-card-inline .document-card-date {
  font-size: 1.1rem;
}

/* Mode smaller */
.document-card-smaller {
  padding: 0.875rem 1rem;
  min-height: 72px;
  flex: 1 1 160px;
  max-width: 320px;
}

.document-card-smaller .document-card-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
}

.document-card-smaller .document-card-icon svg {
  width: 18px;
  height: 18px;
}

.document-card-smaller .document-card-type {
  font-size: 1.3rem;
}

.document-card-smaller .document-card-date {
  font-size: 1.1rem;
}

/* =========================================
   Carte "+" ajouter / mettre à jour
   ========================================= */

.document-add-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  padding: 0.75rem;
  height: 88px;
  aspect-ratio: 1 / 1;
  flex: 0 0 auto;
  align-self: center;
  background: rgba(215, 217, 217, 0.3);
  border: 2px dashed #d1d5db;
  border-radius: 0.75rem;
  cursor: pointer;
  color: #9ca3af;
  font-family: inherit;
  transition:
    border-color 0.15s ease,
    background 0.15s ease,
    color 0.15s ease;
}

.document-add-card:hover:not(:disabled) {
  border-color: #f97316;
  background: #fff7ed;
  color: #f97316;
}

.document-add-card:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Etat "document obligatoire manquant" : rouge, calque sur .photo-dropzone--error des References */
.document-add-card--error {
  border-color: #dc3545;
  background: #fff5f5;
  color: #dc3545;
}

.document-add-card--error:hover:not(:disabled) {
  border-color: #b91c1c;
  background: #fff0f0;
  color: #b91c1c;
}

.document-add-card-plus {
  font-size: 2rem;
  font-weight: 300;
  line-height: 1;
}

.document-add-card-label {
  font-size: 1.1rem;
  font-weight: 500;
  text-align: center;
  line-height: 1.3;
  white-space: nowrap;
}

.document-add-card-hint {
  font-size: 0.95rem;
  font-weight: 400;
  text-align: center;
  color: #b0b7c3;
  white-space: nowrap;
}

.document-add-card-smaller {
  height: 72px;
  padding: 0.5rem;
}

.document-add-card-smaller .document-add-card-plus {
  font-size: 1.6rem;
}

.document-add-card-smaller .document-add-card-label {
  font-size: 1rem;
}

/* =========================================
   Drag-and-drop feedback
   ========================================= */

.document-add-card--drag-over {
  border-color: #f97316;
  background: #fff7ed;
  color: #f97316;
  transform: scale(1.04);
  transition:
    transform 0.1s ease,
    border-color 0.1s ease,
    background 0.1s ease;
}

/* =========================================
   Carte carré (picto centré + date en dessous)
   ========================================= */

.document-card--square {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.875rem 0.5rem 0.75rem;
  /* Taille responsive : s'adapte au conteneur */
  flex: 1 1;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  aspect-ratio: 1 / 1;
  height: unset;
  min-height: unset;
  text-align: center;
}

.document-card--square .document-card-body {
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
}

.document-card--square .document-card-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
}

.document-card--square .document-card-icon svg {
  width: 22px;
  height: 22px;
}

.document-card-date--square {
  font-size: 1.05rem;
  color: #9ca3af;
  text-align: center;
  white-space: normal;
  word-break: break-word;
  line-height: 1.3;
}

/* Skeleton carré */
.document-card-skeleton--square {
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.document-card-skeleton--square .doc-skeleton-icon {
  width: 40px;
  height: 40px;
}

.document-card-skeleton--square .doc-skeleton-body {
  align-items: center;
}

.document-card-skeleton--square .doc-skeleton-line--title {
  width: 60px;
  height: 10px;
}

.document-card-skeleton--square .doc-skeleton-line--date {
  display: none;
}

/* =========================================
   Skeleton loader
   ========================================= */

@keyframes doc-shimmer {
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
}

.document-card-skeleton {
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
}

.doc-skeleton-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  flex-shrink: 0;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 400px 100%;
  animation: doc-shimmer 1.2s ease-in-out infinite;
}

.doc-skeleton-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.doc-skeleton-line {
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 400px 100%;
  animation: doc-shimmer 1.2s ease-in-out infinite;
}

.doc-skeleton-line--title {
  height: 14px;
  width: 40%;
}

.doc-skeleton-line--date {
  height: 11px;
  width: 65%;
}

/* Variant smaller */
.document-card-skeleton--smaller .doc-skeleton-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
}

.document-card-skeleton--smaller .doc-skeleton-line--title {
  height: 12px;
}

.document-card-skeleton--smaller .doc-skeleton-line--date {
  height: 10px;
}

/* =========================================
   Modale preview
   ========================================= */

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content-document {
  background: #ffffff;
  padding: 1.5rem;
  border-radius: 12px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.modal-content-document h3 {
  font-size: 1.6rem;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}

.dl-button-icon-white {
  fill: white !important;
}

/* =========================================
   Carte logo (partagée avec TabDocuments)
   ========================================= */

.logo-card {
  cursor: pointer !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.5rem;
  flex: 0 0 96px;
  width: 96px;
  min-width: 96px;
  max-width: 96px;
  min-height: 96px;
  height: 96px;
}

.logo-card-thumb {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.logo-card-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* =========================================
   Responsive
   ========================================= */

@media (max-width: 600px) {
  .document-card,
  .document-card-smaller {
    flex: 1 1 100%;
    max-width: 100%;
  }

  .document-add-card {
    flex: 1 1 100%;
  }
}

.documents-grid.documents-grid-inline.documents-grid-smaller {
  grid-template-columns: repeat(6, 1fr) !important;
  gap: 8px !important;
}

@media (max-width: 1200px) {
  .documents-grid.documents-grid-inline.documents-grid-smaller {
    grid-template-columns: repeat(4, 1fr) !important;
  }
}

@media (max-width: 768px) {
  .documents-grid.documents-grid-inline.documents-grid-smaller {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

.documents-grid.documents-grid-fullWidth {
  display: grid !important;
  grid-template-columns: 1fr !important;
  gap: 12px !important;
}

.document-card {
  display: flex;
  justify-content: flex-start;
  /* align-items: flex-start !important; */
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #dfdfdf;
  cursor: pointer;
  transition:
    background-color 0.2s,
    transform 0.2s;
  padding: 12px 16px;
}

.document-card-inline {
  width: 100%;
}

.document-card-fullWidth {
  width: 100%;
}

.document-card:hover {
  background-color: #d0d0d0;
  transform: translateY(-2px);
}

.document-left {
  display: flex;
  align-items: flex-start !important;
  gap: 10px;
}

.document-left .document-info {
  align-items: flex-start !important;
  gap: 0;
}

.document-left .document-info .document-type {
  margin: 0;
}

.documents-list .document-card {
  justify-content: flex-start;
}

.document-icon {
  width: 32px;
  height: 32px;
  color: #555;
  background: transparent !important;
}

.document-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.document-type {
  font-weight: 500;
  font-size: 1.5rem !important;
  color: #222;
  background: transparent !important;
  padding: 0 !important;
  text-align: center !important;
}

.document-date {
  font-size: 12px;
  color: #777;
  margin-top: 0.25rem;
}

.document-actions {
  display: flex;
  gap: 8px;
}

.document-actions button {
  border-radius: 12px;
  cursor: pointer;
  margin-top: 1.5rem;
}

.dl-button-icon-white {
  fill: white !important;
  /* stroke: white !important; */
}

/* Loader pour les documents */
.document-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  padding-right: 16px;
}

.document-loading-centered {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 40px;
}

.spinner {
  width: 24px;
  height: 24px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #555;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content-document {
  background: white;
  padding: 20px;
  border-radius: 12px;
  width: 90%;
  max-width: 800px;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.documents-list {
  margin: 2rem 0;
}

/* Variante smaller */
.document-card-smaller {
  padding: 6px !important;
  min-height: 0 !important;
}

.document-card-smaller .document-left {
  gap: 6px;
}

.document-icon-smaller {
  width: 20px;
  height: 20px;
}

.document-type-smaller {
  font-size: 1.2rem !important;
}

.document-date-smaller {
  font-size: 10px;
}

.spinner-smaller {
  width: 16px;
  height: 16px;
  border-width: 2px;
}

.document-card-smaller .document-left .document-info {
  align-items: center !important;
}

.modal-content-document .modal-actions {
  border-top: 0;
}
`, "",{"version":3,"sources":["webpack://./src/composants/DocumentsList/DocumentsList.css"],"names":[],"mappings":"AAAA;;8CAE8C;;AAE9C;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;;;gHAGgH;AAChH;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;;;;uGAIuG;AACvG;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;8CAE8C;;AAE9C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC;;2BAEyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd;;oBAEkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;8CAE8C;;AAE9C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;EAC1B,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB;;;oBAGkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mGAAmG;AACnG;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;8CAE8C;;AAE9C;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB;;;wBAGsB;AACxB;;AAEA;;8CAE8C;;AAE9C;EACE,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gCAAgC;EAChC,8CAA8C;EAC9C,SAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;8CAE8C;;AAE9C;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,yEAAyE;EACzE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yEAAyE;EACzE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;8CAE8C;;AAE9C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;8CAE8C;;AAE9C;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,cAAc;EACd,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;8CAE8C;;AAE9C;EACE;;IAEE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,wCAAwC;EACxC,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf;;kBAEgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,MAAM;AACR;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,WAAW;EACX,kCAAkC;EAClC,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* =========================================\r\n   Documents grid\r\n   ========================================= */\r\n\r\n.documents-list {\r\n  margin: 0.5rem 0;\r\n  min-width: 0;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.documents-grid {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.75rem;\r\n  align-items: stretch;\r\n  min-width: 0;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Carte \"trailing\" (contenu libre passe via le prop `trailingCard`) : occupe DEUX places de carte.\r\n   - variant \"grid\" (display:grid, repeat(4,1fr)) -> grid-column: span 2 (2 des 4 colonnes).\r\n   - variants flex (inline/fullWidth) -> flex 2 1 400px (2x une carte flex 1 1 200px).\r\n   Meme hauteur que les cartes (les items s'etirent sur la ligne). display:flex pour que le contenu remplisse. */\r\n.documents-grid-trailing {\r\n  grid-column: span 2;\r\n  flex: 2 1 400px;\r\n  max-width: 800px;\r\n  min-width: 0;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n}\r\n.documents-grid-trailing > * {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n/* `trailingCardSpan={1}` : la carte tient dans UNE place, comme un document — elle reste donc sur la\r\n   ligne des autres au lieu d'en manger deux. Les DEUX mecanismes de la regle de base sont annules,\r\n   pas seulement le `grid-column` : les variants flex (inline/fullWidth) passent par `flex`, et n'en\r\n   corriger qu'un laisserait la carte double dans la moitie des cas.\r\n   `max-width` remis a la largeur d'une carte flex, sinon les 800px herites la laisseraient s'etaler. */\r\n.documents-grid-trailing--single {\r\n  grid-column: span 1;\r\n  flex: 1 1 200px;\r\n  max-width: 400px;\r\n}\r\n\r\n/* =========================================\r\n   Document card\r\n   ========================================= */\r\n\r\n.document-card {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  padding: 1.125rem 1.25rem;\r\n  background: #ffffff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 0.75rem;\r\n  cursor: pointer;\r\n  flex: 1 1 200px;\r\n  max-width: 400px;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\r\n  transition:\r\n    box-shadow 0.15s ease,\r\n    border-color 0.15s ease;\r\n  min-height: 88px;\r\n}\r\n\r\n.document-card:hover {\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n  border-color: #d1d5db;\r\n}\r\n\r\n/* Icône PDF */\r\n.document-card-icon {\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  border: 1px solid #e5e7eb;\r\n}\r\n\r\n.document-card-icon--green {\r\n  background: #f0fdf4;\r\n  color: #16a34a;\r\n}\r\n\r\n.document-card-icon--orange {\r\n  background: #fff7ed;\r\n  color: #f97316;\r\n}\r\n\r\n.document-card-icon--grey {\r\n  background: #f3f4f6;\r\n  color: #6b7280;\r\n}\r\n\r\n.document-card-icon svg {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n\r\n/* Corps : type + date */\r\n.document-card-body {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.2rem;\r\n}\r\n\r\n.document-card-type {\r\n  font-size: 1.45rem;\r\n  font-weight: 600;\r\n  color: #374151;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  line-height: 1.3;\r\n}\r\n\r\n.document-card-date {\r\n  font-size: 1.2rem;\r\n  color: #9ca3af;\r\n  line-height: 1.2;\r\n}\r\n\r\n/* Bouton téléchargement */\r\n.document-card-download {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 0.4rem;\r\n  border-radius: 6px;\r\n  color: #9ca3af;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  transition:\r\n    background 0.15s ease,\r\n    color 0.15s ease;\r\n}\r\n\r\n.document-card-download:hover:not(:disabled) {\r\n  background: #fff7ed;\r\n  color: #f97316;\r\n}\r\n\r\n.document-card-download:disabled {\r\n  opacity: 0.4;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Variant inline (contextes embarqués, liste compacte) */\r\n.documents-grid-inline {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.5rem;\r\n}\r\n\r\n/* Variant grid (Coordonnées — grille 4 colonnes) */\r\n.documents-grid.documents-grid-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 0.625rem;\r\n  flex-wrap: unset;\r\n}\r\n\r\n.document-card-grid {\r\n  flex: unset;\r\n  max-width: unset;\r\n  min-height: unset;\r\n  padding: 0.75rem 1rem;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.document-card-grid .document-card-icon {\r\n  width: 54px;\r\n  height: 54px;\r\n  border-radius: 12px;\r\n}\r\n\r\n.document-card-grid .document-card-icon svg {\r\n  width: 27px;\r\n  height: 27px;\r\n}\r\n\r\n.document-card-grid .document-card-type {\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.document-card-grid .document-card-date {\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.document-card-inline {\r\n  flex: unset;\r\n  max-width: unset;\r\n  min-height: unset;\r\n  padding: 0.75rem 1rem;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.document-card-inline .document-card-icon {\r\n  width: 54px;\r\n  height: 54px;\r\n  border-radius: 12px;\r\n}\r\n\r\n.document-card-inline .document-card-icon svg {\r\n  width: 27px;\r\n  height: 27px;\r\n}\r\n\r\n.document-card-inline .document-card-type {\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.document-card-inline .document-card-date {\r\n  font-size: 1.1rem;\r\n}\r\n\r\n/* Mode smaller */\r\n.document-card-smaller {\r\n  padding: 0.875rem 1rem;\r\n  min-height: 72px;\r\n  flex: 1 1 160px;\r\n  max-width: 320px;\r\n}\r\n\r\n.document-card-smaller .document-card-icon {\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.document-card-smaller .document-card-icon svg {\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n\r\n.document-card-smaller .document-card-type {\r\n  font-size: 1.3rem;\r\n}\r\n\r\n.document-card-smaller .document-card-date {\r\n  font-size: 1.1rem;\r\n}\r\n\r\n/* =========================================\r\n   Carte \"+\" ajouter / mettre à jour\r\n   ========================================= */\r\n\r\n.document-add-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.3rem;\r\n  padding: 0.75rem;\r\n  height: 88px;\r\n  aspect-ratio: 1 / 1;\r\n  flex: 0 0 auto;\r\n  align-self: center;\r\n  background: rgba(215, 217, 217, 0.3);\r\n  border: 2px dashed #d1d5db;\r\n  border-radius: 0.75rem;\r\n  cursor: pointer;\r\n  color: #9ca3af;\r\n  font-family: inherit;\r\n  transition:\r\n    border-color 0.15s ease,\r\n    background 0.15s ease,\r\n    color 0.15s ease;\r\n}\r\n\r\n.document-add-card:hover:not(:disabled) {\r\n  border-color: #f97316;\r\n  background: #fff7ed;\r\n  color: #f97316;\r\n}\r\n\r\n.document-add-card:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Etat \"document obligatoire manquant\" : rouge, calque sur .photo-dropzone--error des References */\r\n.document-add-card--error {\r\n  border-color: #dc3545;\r\n  background: #fff5f5;\r\n  color: #dc3545;\r\n}\r\n\r\n.document-add-card--error:hover:not(:disabled) {\r\n  border-color: #b91c1c;\r\n  background: #fff0f0;\r\n  color: #b91c1c;\r\n}\r\n\r\n.document-add-card-plus {\r\n  font-size: 2rem;\r\n  font-weight: 300;\r\n  line-height: 1;\r\n}\r\n\r\n.document-add-card-label {\r\n  font-size: 1.1rem;\r\n  font-weight: 500;\r\n  text-align: center;\r\n  line-height: 1.3;\r\n  white-space: nowrap;\r\n}\r\n\r\n.document-add-card-hint {\r\n  font-size: 0.95rem;\r\n  font-weight: 400;\r\n  text-align: center;\r\n  color: #b0b7c3;\r\n  white-space: nowrap;\r\n}\r\n\r\n.document-add-card-smaller {\r\n  height: 72px;\r\n  padding: 0.5rem;\r\n}\r\n\r\n.document-add-card-smaller .document-add-card-plus {\r\n  font-size: 1.6rem;\r\n}\r\n\r\n.document-add-card-smaller .document-add-card-label {\r\n  font-size: 1rem;\r\n}\r\n\r\n/* =========================================\r\n   Drag-and-drop feedback\r\n   ========================================= */\r\n\r\n.document-add-card--drag-over {\r\n  border-color: #f97316;\r\n  background: #fff7ed;\r\n  color: #f97316;\r\n  transform: scale(1.04);\r\n  transition:\r\n    transform 0.1s ease,\r\n    border-color 0.1s ease,\r\n    background 0.1s ease;\r\n}\r\n\r\n/* =========================================\r\n   Carte carré (picto centré + date en dessous)\r\n   ========================================= */\r\n\r\n.document-card--square {\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n  padding: 0.875rem 0.5rem 0.75rem;\r\n  /* Taille responsive : s'adapte au conteneur */\r\n  flex: 1 1 0;\r\n  width: 100%;\r\n  min-width: 0;\r\n  max-width: 100%;\r\n  aspect-ratio: 1 / 1;\r\n  height: unset;\r\n  min-height: unset;\r\n  text-align: center;\r\n}\r\n\r\n.document-card--square .document-card-body {\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.15rem;\r\n}\r\n\r\n.document-card--square .document-card-icon {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.document-card--square .document-card-icon svg {\r\n  width: 22px;\r\n  height: 22px;\r\n}\r\n\r\n.document-card-date--square {\r\n  font-size: 1.05rem;\r\n  color: #9ca3af;\r\n  text-align: center;\r\n  white-space: normal;\r\n  word-break: break-word;\r\n  line-height: 1.3;\r\n}\r\n\r\n/* Skeleton carré */\r\n.document-card-skeleton--square {\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.document-card-skeleton--square .doc-skeleton-icon {\r\n  width: 40px;\r\n  height: 40px;\r\n}\r\n\r\n.document-card-skeleton--square .doc-skeleton-body {\r\n  align-items: center;\r\n}\r\n\r\n.document-card-skeleton--square .doc-skeleton-line--title {\r\n  width: 60px;\r\n  height: 10px;\r\n}\r\n\r\n.document-card-skeleton--square .doc-skeleton-line--date {\r\n  display: none;\r\n}\r\n\r\n/* =========================================\r\n   Skeleton loader\r\n   ========================================= */\r\n\r\n@keyframes doc-shimmer {\r\n  0% {\r\n    background-position: -400px 0;\r\n  }\r\n  100% {\r\n    background-position: 400px 0;\r\n  }\r\n}\r\n\r\n.document-card-skeleton {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  width: 100%;\r\n}\r\n\r\n.doc-skeleton-icon {\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 10px;\r\n  flex-shrink: 0;\r\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\r\n  background-size: 400px 100%;\r\n  animation: doc-shimmer 1.2s ease-in-out infinite;\r\n}\r\n\r\n.doc-skeleton-body {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.doc-skeleton-line {\r\n  border-radius: 4px;\r\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\r\n  background-size: 400px 100%;\r\n  animation: doc-shimmer 1.2s ease-in-out infinite;\r\n}\r\n\r\n.doc-skeleton-line--title {\r\n  height: 14px;\r\n  width: 40%;\r\n}\r\n\r\n.doc-skeleton-line--date {\r\n  height: 11px;\r\n  width: 65%;\r\n}\r\n\r\n/* Variant smaller */\r\n.document-card-skeleton--smaller .doc-skeleton-icon {\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.document-card-skeleton--smaller .doc-skeleton-line--title {\r\n  height: 12px;\r\n}\r\n\r\n.document-card-skeleton--smaller .doc-skeleton-line--date {\r\n  height: 10px;\r\n}\r\n\r\n/* =========================================\r\n   Modale preview\r\n   ========================================= */\r\n\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal-content-document {\r\n  background: #ffffff;\r\n  padding: 1.5rem;\r\n  border-radius: 12px;\r\n  width: 90%;\r\n  max-width: 800px;\r\n  max-height: 90vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.modal-content-document h3 {\r\n  font-size: 1.6rem;\r\n  font-weight: 600;\r\n  color: #374151;\r\n  margin: 0;\r\n}\r\n\r\n.modal-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.dl-button-icon-white {\r\n  fill: white !important;\r\n}\r\n\r\n/* =========================================\r\n   Carte logo (partagée avec TabDocuments)\r\n   ========================================= */\r\n\r\n.logo-card {\r\n  cursor: pointer !important;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.4rem;\r\n  padding: 0.5rem;\r\n  flex: 0 0 96px;\r\n  width: 96px;\r\n  min-width: 96px;\r\n  max-width: 96px;\r\n  min-height: 96px;\r\n  height: 96px;\r\n}\r\n\r\n.logo-card-thumb {\r\n  width: 64px;\r\n  height: 64px;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  background: #ffffff;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.logo-card-img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: contain;\r\n}\r\n\r\n/* =========================================\r\n   Responsive\r\n   ========================================= */\r\n\r\n@media (max-width: 600px) {\r\n  .document-card,\r\n  .document-card-smaller {\r\n    flex: 1 1 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .document-add-card {\r\n    flex: 1 1 100%;\r\n  }\r\n}\r\n\r\n.documents-grid.documents-grid-inline.documents-grid-smaller {\r\n  grid-template-columns: repeat(6, 1fr) !important;\r\n  gap: 8px !important;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .documents-grid.documents-grid-inline.documents-grid-smaller {\r\n    grid-template-columns: repeat(4, 1fr) !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .documents-grid.documents-grid-inline.documents-grid-smaller {\r\n    grid-template-columns: repeat(2, 1fr) !important;\r\n  }\r\n}\r\n\r\n.documents-grid.documents-grid-fullWidth {\r\n  display: grid !important;\r\n  grid-template-columns: 1fr !important;\r\n  gap: 12px !important;\r\n}\r\n\r\n.document-card {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  /* align-items: flex-start !important; */\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  background-color: #dfdfdf;\r\n  cursor: pointer;\r\n  transition:\r\n    background-color 0.2s,\r\n    transform 0.2s;\r\n  padding: 12px 16px;\r\n}\r\n\r\n.document-card-inline {\r\n  width: 100%;\r\n}\r\n\r\n.document-card-fullWidth {\r\n  width: 100%;\r\n}\r\n\r\n.document-card:hover {\r\n  background-color: #d0d0d0;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.document-left {\r\n  display: flex;\r\n  align-items: flex-start !important;\r\n  gap: 10px;\r\n}\r\n\r\n.document-left .document-info {\r\n  align-items: flex-start !important;\r\n  gap: 0;\r\n}\r\n\r\n.document-left .document-info .document-type {\r\n  margin: 0;\r\n}\r\n\r\n.documents-list .document-card {\r\n  justify-content: flex-start;\r\n}\r\n\r\n.document-icon {\r\n  width: 32px;\r\n  height: 32px;\r\n  color: #555;\r\n  background: transparent !important;\r\n}\r\n\r\n.document-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.document-type {\r\n  font-weight: 500;\r\n  font-size: 1.5rem !important;\r\n  color: #222;\r\n  background: transparent !important;\r\n  padding: 0 !important;\r\n  text-align: center !important;\r\n}\r\n\r\n.document-date {\r\n  font-size: 12px;\r\n  color: #777;\r\n  margin-top: 0.25rem;\r\n}\r\n\r\n.document-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.document-actions button {\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.dl-button-icon-white {\r\n  fill: white !important;\r\n  /* stroke: white !important; */\r\n}\r\n\r\n/* Loader pour les documents */\r\n.document-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-left: auto;\r\n  padding-right: 16px;\r\n}\r\n\r\n.document-loading-centered {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n  min-height: 40px;\r\n}\r\n\r\n.spinner {\r\n  width: 24px;\r\n  height: 24px;\r\n  border: 3px solid #f3f3f3;\r\n  border-top: 3px solid #555;\r\n  border-radius: 50%;\r\n  animation: spin 0.8s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal-content-document {\r\n  background: white;\r\n  padding: 20px;\r\n  border-radius: 12px;\r\n  width: 90%;\r\n  max-width: 800px;\r\n  max-height: 90%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.modal-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n}\r\n\r\n.documents-list {\r\n  margin: 2rem 0;\r\n}\r\n\r\n/* Variante smaller */\r\n.document-card-smaller {\r\n  padding: 6px !important;\r\n  min-height: 0 !important;\r\n}\r\n\r\n.document-card-smaller .document-left {\r\n  gap: 6px;\r\n}\r\n\r\n.document-icon-smaller {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.document-type-smaller {\r\n  font-size: 1.2rem !important;\r\n}\r\n\r\n.document-date-smaller {\r\n  font-size: 10px;\r\n}\r\n\r\n.spinner-smaller {\r\n  width: 16px;\r\n  height: 16px;\r\n  border-width: 2px;\r\n}\r\n\r\n.document-card-smaller .document-left .document-info {\r\n  align-items: center !important;\r\n}\r\n\r\n.modal-content-document .modal-actions {\r\n  border-top: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
